/* eslint-disable no-unused-vars */
import { CustomInput, Upload, CustomTooltip, FileUploader, Loader } from 'components';
import { DeleteIcon } from 'assets/icons';
import { useForm, Controller } from 'react-hook-form';
import * as S from './NewAppTab.styled';
import Footer from '../../footer/Footer';
import ChooseCategory from '../../chooseCategory/ChooseCategory';
import { formDataFromObject } from 'utils';
import { newAppPages } from 'constants';
import PropTypes from 'prop-types';
import { manageAppsAPI } from 'services/manageApps.service';
import { useEffect } from 'react';

export const NewAppTab = ({ handleClose, page, chooseAction }) => {
  const { data: categories } = manageAppsAPI.useGetAllAppsCategoriesQuery();
  const [saveUnpublishedGoogleApp, result] = manageAppsAPI.useSaveUnpublishedAppMutation();

  const onSubmit = async (data) => {
    const catValue = categories.find((cat) => cat.application_type_name === data.category);
    const newData = {
      appName: data.appName.trim(),
      appIcon: data.appIcon,
      packageName: data.packageName,
      category: catValue.application_type_id,
    };
    let appId = '';
    if (data.apk) {
      newData.apk = data.apk;
    }
    if (page === newAppPages.samsung) {
      console.log('save new samsung app', newData);
    } else if (page === newAppPages.xiaomi) {
      console.log('save new xiaomi app', newData);
    } else if (page === newAppPages.google) {
      console.log('save new google app', newData);
      const res = await saveUnpublishedGoogleApp(formDataFromObject(newData));
      chooseAction(res);
      appId = res.data.apps.appId;
    }
    handleClose(appId);
  };

  const {
    reset,
    handleSubmit,
    setValue,
    clearErrors,
    control,
    formState: {
      isDirty,
      errors,
      isValid,
      isSubmitted,
      isSubmitSuccessful,
      isSubmitting,
      isLoading,
    },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      appName: '',
      appIcon: null,
      packageName: '',
      category: '',
    },
  });

  useEffect(() => {
    reset();
  }, [page]);

  return (
    <S.Form onSubmit={handleSubmit(onSubmit)} id='samsAndX'>
      {result.isLoading && <Loader.Global delay={0} />}
      <S.Container>
        <S.Field>
          <S.Label htmlFor='appName'>App name:</S.Label>
          <Controller
            name='appName'
            control={control}
            rules={{
              required: 'this field is required',
              validate: (value) => value?.trim().length > 0 || 'Input cannot be only spaces',
            }}
            render={({ field: { onChange, value } }) => (
              <CustomInput
                value={value}
                onChange={onChange}
                id='appName'
                name='appName'
                rightIconOnClick={() => {
                  setValue('appName', '', { shouldDirty: true });
                  clearErrors('appName');
                }}
                rightIcon={value.length ? <DeleteIcon /> : null}
                containerStyle={{ marginBottom: '26px' }}
                error={!!errors?.appName}
                errorText={errors?.appName?.message}
              />
            )}
          />
        </S.Field>
        <S.Field>
          <S.ReqWrapper>
            <S.Label htmlFor='appIcon'>App Icon:</S.Label>
            <S.Requirements>
              Requirements
              <CustomTooltip
                content={<S.Marker>?</S.Marker>}
                text={
                  <p>
                    JPEG or PNG.
                    <br />
                    Please upload image size 512*512.
                  </p>
                }
              />
            </S.Requirements>
          </S.ReqWrapper>
          <Controller
            name='appIcon'
            control={control}
            rules={{
              required: 'this field is required',
            }}
            render={({ field: { onChange } }) => (
              <Upload
                accept='image/jpeg, image/jpg, image/png, image/gif'
                buttonText='Choose File'
                id='appIcon'
                size={Upload.Size?.Big}
                maxWidth={512}
                maxHeight={512}
                onChange={onChange}
                containerStyle={{ marginBottom: '26px' }}
                error={!!errors?.appIcon}
                errorText={errors?.appIcon?.message}
              />
            )}
          />
        </S.Field>

        {/* <S.Field style={{ marginBottom: '24px' }}>
          <S.ReqWrapper style={{ justifyContent: 'flex-start' }}>
            <S.Label htmlFor='apk'>APK:</S.Label>
            <CustomTooltip content={<S.Marker>?</S.Marker>} text='Requirements for this field' />
          </S.ReqWrapper>
          <Controller
            name='apk'
            control={control}
            render={({ field: { onChange } }) => (
              <FileUploader
                availableTypes={['application/zip', 'application/vnd.android.package-archive']}
                alertMessage='Please select a APK or ZIP file up to 60 MB in size.'
                accept='.apk, .zip'
                onChange={onChange}
                error={!!errors?.apk}
                errorText={errors?.apk?.message}
              />
            )}
          />
        </S.Field> */}
        {page !== 'google' && (
          <S.Field>
            <S.Label htmlFor='packageName'>Package name:</S.Label>
            <Controller
              name='packageName'
              control={control}
              rules={{
                required: 'this field is required',
              }}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  value={value}
                  onChange={onChange}
                  id='packageName'
                  name='packageName'
                  rightIconOnClick={() => setValue('packageName', null, { shouldDirty: true })}
                  rightIcon={value.length ? <DeleteIcon /> : null}
                  containerStyle={{ marginBottom: '26px' }}
                  error={!!errors?.packageName}
                  errorText={errors?.packageName?.message}
                />
              )}
            />
          </S.Field>
        )}
        <S.Field>
          <S.Label htmlFor='category'>Category:</S.Label>
          <Controller
            name='category'
            control={control}
            rules={{
              required: 'this field is required',
            }}
            render={({ field: { onChange, value } }) => (
              <ChooseCategory
                id='category'
                category={value}
                onChange={onChange}
                error={!!errors?.category}
                errorText={errors?.category?.message}
                setValue={setValue}
              />
            )}
          />
        </S.Field>
      </S.Container>
      <Footer
        handleClose={handleClose}
        handleSaveApp={handleSubmit}
        typeSaveBtn='submit'
        isDisabled={!isValid || isSubmitting || result.isLoading}
      />
    </S.Form>
  );
};

NewAppTab.propTypes = {
  handleClose: PropTypes.func.isRequired,
  page: PropTypes.oneOf(['google', 'samsung', 'xiaomi']).isRequired,
};
